import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { formatPrice } from '../../../../../shared/helpers/formatPrice';
import { StyledDescriptionList } from '../../BookingInformation.styles';

interface BookingLandlordPaymentInformationProps {
  proposal: number;
  monthlyFee: number;
  yearlyEarnings: number;
}

const BookingLandlordPaymentInformation = ({
  proposal,
  monthlyFee,
  yearlyEarnings,
}: BookingLandlordPaymentInformationProps) => {
  const { t } = useTranslation(['booking']);
  return (
    <StyledDescriptionList>
      <div>
        <dt>{upperFirst(t('booking:offer'))}</dt>
        <dd>{formatPrice(proposal)}</dd>
      </div>
      <div>
        <dt>{upperFirst(t('booking:monthlyEarnings'))}</dt>
        <dd>{formatPrice(proposal - monthlyFee)}</dd>
      </div>
      <div>
        <dt>{upperFirst(t('booking:monthlyFee'))}</dt>
        <dd>{formatPrice(monthlyFee)}</dd>
      </div>
      <div>
        <dt>{upperFirst(t('booking:yearlyEarnings'))}</dt>
        <dd>{formatPrice(yearlyEarnings)}</dd>
      </div>
    </StyledDescriptionList>
  );
};

export default BookingLandlordPaymentInformation;
